import { IssueData, ZodIssueCode } from 'zod';
import { doesExist } from 'utils/tsHelpers';
import { AnyComparator } from '../../types';

/**
 * Util to validate condition comparators
 * Checks if comparator is missing.
 */
export const validateEmptyComparator = (
  {
    comparatorType,
  }: {
    comparatorType?: AnyComparator;
  },
  addIssue: (arg: IssueData) => void,
) => {
  if (!doesExist(comparatorType)) {
    addIssue({
      code: ZodIssueCode.custom,
      message: 'missing comparator',
      path: ['comparatorType'],
    });
  }
};
